import { httpsCallable } from "firebase/functions";
import { getFirebaseFunctions } from "../firebase.ts";
import type { FactoringNotification } from "./factoringModel";

interface Request {}

interface Response {
  success: boolean;
  factoringNotifications: FactoringNotification[];
}

export const swrKey = "getFactoringNotifications";

export const factoringNotificationsFetcher = async () => {
  const functions = getFirebaseFunctions();
  const getFactoringNotificationsFunction = httpsCallable<Request, Response>(
    functions,
    swrKey,
  );
  const res = await getFactoringNotificationsFunction();
  return res.data.factoringNotifications;
};
